import React, { FC } from "react";
import classnames from "classnames";

import { getKey, useColumnsConfig } from "../../utils";
import { Direction, TableHeaderProps, TableHeaderSort } from "./types";
import { ITableColumnConfig } from "../../types";
import Icon from "../../../Icon";
import { IconName } from "../../../Icon/types";

export const TableHeader: FC<TableHeaderProps> = ({
  defaultSort,
  onSort,
  isExpanded,
  ...props
}) => {
  const columns = useColumnsConfig(props.columns);

  const sortHandler = (column: ITableColumnConfig) => {
    return () => {
      if (column.sortable === false) {
        return;
      }

      let direction: Direction;

      if (defaultSort?.field === column.field) {
        direction = defaultSort.direction === "asc" ? "desc" : "asc";
      } else {
        direction = column.defaultSort || "asc";
      }

      const data: TableHeaderSort = {
        field: column.field,
        direction,
      };

      if (onSort) {
        onSort(data);
      }
    };
  };

  const renderSortIcon = (column: ITableColumnConfig) => {
    if (defaultSort?.field === column.field) {
      const iconName: IconName =
        defaultSort.direction === "asc" ? "down" : "up";

      return <Icon>{iconName}</Icon>;
    }

    return null;
  };

  return (
    <thead className="ams-table__header">
      <tr className="ams-table__row">
        {isExpanded ? (
          <th className="ams-table__cell ams-table__expand"></th>
        ) : null}
        {columns.map((column, index) => {
          const value = column.headerCellRenderer({ column });
          const isActived = defaultSort?.field === column.field;

          return (
            <th
              className={classnames("ams-table__cell", column.cellClass, {
                "ams-table__cell__active": isActived,
              })}
              key={getKey("th", index)}
              onClick={sortHandler(column)}
            >
              <div className="ams-table__cell__container">{value}</div>
              {renderSortIcon(column)}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
